<script lang="ts">
	import { fade, fly } from "svelte/transition";
	import { useDrawer } from "./useDrawer";

	const { component, close, options } = useDrawer();

	function getValue(from: "bottom" | "left") {
		switch (from) {
			case "bottom":
				return {
					x: 0,
					y: 1000
				};
			case "left": {
				return {
					x: -1000,
					y: 0
				};
			}
			default:
				return {
					x: 0,
					y: 1000
				};
		}
	}

	$: values = getValue($options?.from);
</script>

<div
	class="fixed z-[9999] h-full max-h-screen w-screen {!$component
		? 'pointer-events-none hidden'
		: $options?.fullscreen && 'bg-white'}"
>
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	{#if $component}
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div
			on:click={() => {
				close();
			}}
			transition:fade={{
				duration: 100
			}}
			class="h-full w-full bg-black/40"
		></div>

		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<div
			on:click={() => {
				if ($options.closeOnContentClick) {
					close();
				}
			}}
			transition:fly={{
				duration: 400,
				...values,
				opacity: 0.5
			}}
			class=" max-w-screen absolute z-[9999] max-h-screen w-full overflow-x-hidden overflow-y-scroll bg-white
				{$options.from === 'bottom' && 'bottom-0'}
				{$options.from === 'left' && 'top-0 h-full'}
			"
		>
			<svelte:component this={$component} {...$options.componentProps} />
		</div>
	{/if}
</div>
